import { render, staticRenderFns } from "./CompanyFaq.vue?vue&type=template&id=4949d4f8&scoped=true"
import script from "./CompanyFaq.vue?vue&type=script&lang=js"
export * from "./CompanyFaq.vue?vue&type=script&lang=js"
import style0 from "./CompanyFaq.vue?vue&type=style&index=0&id=4949d4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949d4f8",
  null
  
)

export default component.exports